export const createImage = async (url: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (error) => reject(error));
        // Como Braindog sube desde local (Base64) o URL externa, el Canvas fallará
        // al exportar si ponemos 'anonymous' a cosas que no lo son. Lo dejamos default.
        image.src = url;
    });
};

export function getRadianAngle(degreeValue: number) {
    return (degreeValue * Math.PI) / 180
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */
export function rotateSize(width: number, height: number, rotation: number) {
    const rotRad = getRadianAngle(rotation)

    return {
        width:
            Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height:
            Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
    }
}

export default async function getCroppedImg(
    imageSrc: string,
    pixelCrop: { x: number, y: number, width: number, height: number }
): Promise<string> {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
        return '';
    }

    // El secreto oscuro de react-easy-crop es que el 'pixelCrop' asume dimensiones reales.
    // canvas size should be exactly the crop dimension
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    // Put image on canvas cropped
    ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
    );

    // Resize for efficiency if it is too huge
    const MAX_SIZE = 500;
    if (canvas.width > MAX_SIZE || canvas.height > MAX_SIZE) {
        const outCanvas = document.createElement('canvas');
        const outCtx = outCanvas.getContext('2d');
        if (outCtx) {
            let targetW = canvas.width;
            let targetH = canvas.height;
            if (targetW > targetH) {
                targetH = Math.round((targetH * MAX_SIZE) / targetW);
                targetW = MAX_SIZE;
            } else {
                targetW = Math.round((targetW * MAX_SIZE) / targetH);
                targetH = MAX_SIZE;
            }
            outCanvas.width = targetW;
            outCanvas.height = targetH;
            
            // Draw scaled down
            outCtx.drawImage(canvas, 0, 0, targetW, targetH);
            return outCanvas.toDataURL('image/jpeg', 0.9);
        }
    }

    // Return Base64
    return canvas.toDataURL('image/jpeg', 0.9);
}
